<template>
  <div class="pwc-event">
    <van-nav-bar
      title="活动详情"
      left-arrow
      fixed
      @click-left="handleReturn"
    />
    <pwc-container>
      <event-detail :event="detail" class="pwc-event-detail" @eventEnd="handleEventEnd" />
    </pwc-container>
    <van-button
      class="pwc-register"
      type="primary"
      size="normal"
      @click="handleRegister()"
      :disabled="eventEnd"
    >{{ cRegisterText }}</van-button>

    <van-dialog
      v-model="show"
      title=""
      :confirm="closeRegisterEnd"
    >
      <div class="pwc-info-tilte">
        感谢参与！
      </div>
      <div class="pwc-info-content">
        {{ cDes }}
      </div>
      <div class="pwc-info-qrcode">
        <img :src="cAssitanWechat">
      </div>
    </van-dialog>
  </div>
</template>

<script>
import EventDetail from '@/components/EventDetail/mobile'
import { loading } from '@/mixin'
import { store, logic } from '../common/mixin/logic'
import { NavBar, Button } from 'vant'
import PwcContainer from '@/views/layout/mobile/PwcContainer'

export default {
  components: {
    VanNavBar: NavBar,
    VanButton: Button,
    PwcContainer,
    EventDetail
  },
  mixins: [loading, store, logic],
  data() {
    return {
      id: this.$route.query.id,
      show: false,
      eventEnd: true
    }
  },
  methods: {
    showDialogInfo(msg) {
      this.$dialog.alert({
        message: msg,
        confirmButtonText: '确定'
      })
    },
    showRegisterEnd() {
      this.show = true
    },
    closeRegisterEnd() {
      this.show = false
    },
    handleEventEnd(val) {
      this.eventEnd = val
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-event {
  overflow: hidden;
  .pwc-event-detail {
    margin-bottom: 44px;
  }
  .pwc-register {
    position: fixed;
    width: 100%;
    bottom: 0;
  }
  .pwc-info-qrcode {
        text-align: center;
        img {
            width:180px;
            height:180px;
        }
    }
    .pwc-info-content {
        padding-left: 20px;
        padding-right:20px;
        font-weight: bold;
        margin-bottom: 16px;
    }
    .pwc-info-tilte {
        margin-top: 16px;
        margin-bottom: 15px;
        text-align: center;
        font-weight: bold;

    }
}
</style>
